import type { IconSize, IconSource } from './Icon.vue';
import SphIcon from './Icon.vue';

export { SphIcon };
export type { IconSize, IconSource };
export default SphIcon;
